module.exports = __webpack_public_path__ + "lp/img/up-icon-request.b2fe962b.svg";